var map = {
	"./admin/admin.module": [
		"./src/app/admin/admin.module.ts",
		"admin-admin-module"
	],
	"./adminhome/adminhome.module": [
		"./src/app/adminhome/adminhome.module.ts",
		"adminhome-adminhome-module"
	],
	"./agregardieta/agregardieta.module": [
		"./src/app/agregardieta/agregardieta.module.ts",
		"agregardieta-agregardieta-module"
	],
	"./agregarejercicio/agregarejercicio.module": [
		"./src/app/agregarejercicio/agregarejercicio.module.ts",
		"agregarejercicio-agregarejercicio-module"
	],
	"./agregarplan/agregarplan.module": [
		"./src/app/agregarplan/agregarplan.module.ts",
		"agregarplan-agregarplan-module"
	],
	"./agregarplato/agregarplato.module": [
		"./src/app/agregarplato/agregarplato.module.ts",
		"agregarplato-agregarplato-module"
	],
	"./ejercicio/ejercicio.module": [
		"./src/app/ejercicio/ejercicio.module.ts",
		"default~ejercicio-ejercicio-module~tabs-tabs-module",
		"common",
		"ejercicio-ejercicio-module"
	],
	"./ejercicioadmin/ejercicioadmin.module": [
		"./src/app/ejercicioadmin/ejercicioadmin.module.ts",
		"ejercicioadmin-ejercicioadmin-module"
	],
	"./ejercicioeditarejercicio/ejercicioeditarejercicio.module": [
		"./src/app/ejercicioeditarejercicio/ejercicioeditarejercicio.module.ts",
		"ejercicioeditarejercicio-ejercicioeditarejercicio-module"
	],
	"./ejercicioeditarplan/ejercicioeditarplan.module": [
		"./src/app/ejercicioeditarplan/ejercicioeditarplan.module.ts",
		"ejercicioeditarplan-ejercicioeditarplan-module"
	],
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		"home-home-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"login-login-module"
	],
	"./micuenta/micuenta.module": [
		"./src/app/micuenta/micuenta.module.ts",
		"micuenta-micuenta-module"
	],
	"./misdietas/misdietas.module": [
		"./src/app/misdietas/misdietas.module.ts",
		"misdietas-misdietas-module"
	],
	"./misgraficas/misgraficas.module": [
		"./src/app/misgraficas/misgraficas.module.ts",
		"default~misgraficas-misgraficas-module~reporteadmin-reporteadmin-module",
		"common",
		"misgraficas-misgraficas-module"
	],
	"./misplanes/misplanes.module": [
		"./src/app/misplanes/misplanes.module.ts",
		"misplanes-misplanes-module"
	],
	"./nutricion/nutricion.module": [
		"./src/app/nutricion/nutricion.module.ts",
		"default~nutricion-nutricion-module~tabs-tabs-module",
		"common",
		"nutricion-nutricion-module"
	],
	"./nutricionadmin/nutricionadmin.module": [
		"./src/app/nutricionadmin/nutricionadmin.module.ts",
		"nutricionadmin-nutricionadmin-module"
	],
	"./nutricioneditardieta/nutricioneditardieta.module": [
		"./src/app/nutricioneditardieta/nutricioneditardieta.module.ts",
		"nutricioneditardieta-nutricioneditardieta-module"
	],
	"./nutricioneditarplato/nutricioneditarplato.module": [
		"./src/app/nutricioneditarplato/nutricioneditarplato.module.ts",
		"nutricioneditarplato-nutricioneditarplato-module"
	],
	"./popo/popo.module": [
		"./src/app/popo/popo.module.ts"
	],
	"./popopeso/popopeso.module": [
		"./src/app/popopeso/popopeso.module.ts"
	],
	"./register/register.module": [
		"./src/app/register/register.module.ts",
		"register-register-module"
	],
	"./reporteadmin/reporteadmin.module": [
		"./src/app/reporteadmin/reporteadmin.module.ts",
		"default~misgraficas-misgraficas-module~reporteadmin-reporteadmin-module",
		"common",
		"reporteadmin-reporteadmin-module"
	],
	"./tabs/tabs.module": [
		"./src/app/tabs/tabs.module.ts",
		"default~nutricion-nutricion-module~tabs-tabs-module",
		"default~ejercicio-ejercicio-module~tabs-tabs-module",
		"common",
		"tabs-tabs-module"
	],
	"./terminos/terminos.module": [
		"./src/app/terminos/terminos.module.ts",
		"terminos-terminos-module"
	],
	"./tuto/tuto.module": [
		"./src/app/tuto/tuto.module.ts",
		"tuto-tuto-module"
	],
	"./tutoinicio/tutoinicio.module": [
		"./src/app/tutoinicio/tutoinicio.module.ts",
		"tutoinicio-tutoinicio-module"
	],
	"./userhome/userhome.module": [
		"./src/app/userhome/userhome.module.ts",
		"userhome-userhome-module"
	],
	"./verejerciciosmisplanes/verejerciciosmisplanes.module": [
		"./src/app/verejerciciosmisplanes/verejerciciosmisplanes.module.ts",
		"verejerciciosmisplanes-verejerciciosmisplanes-module"
	],
	"./verejerciciosplan/verejerciciosplan.module": [
		"./src/app/verejerciciosplan/verejerciciosplan.module.ts",
		"verejerciciosplan-verejerciciosplan-module"
	],
	"./verejerciciosplanuser/verejerciciosplanuser.module": [
		"./src/app/verejerciciosplanuser/verejerciciosplanuser.module.ts",
		"verejerciciosplanuser-verejerciciosplanuser-module"
	],
	"./verplatosdieta/verplatosdieta.module": [
		"./src/app/verplatosdieta/verplatosdieta.module.ts",
		"verplatosdieta-verplatosdieta-module"
	],
	"./verplatosdietauser/verplatosdietauser.module": [
		"./src/app/verplatosdietauser/verplatosdietauser.module.ts",
		"verplatosdietauser-verplatosdietauser-module"
	],
	"./verplatosmisdietas/verplatosmisdietas.module": [
		"./src/app/verplatosmisdietas/verplatosmisdietas.module.ts",
		"verplatosmisdietas-verplatosmisdietas-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;